import { generateToastMessageTradeData } from "@/lib/notifications/toastNotificationHelpers";
import { fetchRequestWrapper } from "@/lib/utilities";

export async function getBookResponse(
  esid: string,
  getAccessTokenSilently: Function,
) {
  // const portfolioCodeList = []
  const bookResponse = await fetchRequestWrapper(
    { url: `/Trade/Execution/Book/${esid}` },
    getAccessTokenSilently,
  );
  if (bookResponse) {
    return bookResponse;
  }
  return "";
}

export async function putBookResponse(
  esid: string,
  executionRequestId: number,
  blockId: number,
  allocationId: number,
  portfolio: string,
  getAccessTokenSilently: Function,
) {
  const outgoingMessage = {
    esid: esid,
    executionRequestId: executionRequestId,
    legs: [
      {
        blockId: blockId,
        allocations: [{ allocationId: allocationId, portfolio: portfolio }],
      },
    ],
  };
  const saveBookResponse = await fetchRequestWrapper(
    {
      url: `/Trade/Execution/Book`,
      method: "PUT",
      objToSend: outgoingMessage,
    },
    getAccessTokenSilently,
  );
  if (saveBookResponse) {
    generateToastMessageTradeData({
      action: "updateBook",
      result: "success",
      ESIDPassed: esid,
    });
  } else {
    generateToastMessageTradeData({
      action: "updateBook",
      result: "error",
    });
  }
  return "";
}
